import type { PendingMemo } from '../types/app'

export const OPEN_MEMO_READER = 'open-memo-reader'
/** Fired after a memo is accepted, so lists and badges can update. */
export const MEMO_ACCEPTED = 'memo-accepted'

export type OpenMemoReaderDetail = { memo: PendingMemo; email: string }
export type MemoAcceptedDetail = { junctionId: string }

/** Opens the memo reader hosted by the layout. `email` is whose memo list it came from. */
export function openMemoReader(memo: PendingMemo, email: string) {
  window.dispatchEvent(
    new CustomEvent<OpenMemoReaderDetail>(OPEN_MEMO_READER, { detail: { memo, email } })
  )
}

export function announceMemoAccepted(junctionId: string) {
  window.dispatchEvent(
    new CustomEvent<MemoAcceptedDetail>(MEMO_ACCEPTED, { detail: { junctionId } })
  )
}

export function memoAcceptedDetail(event: Event): MemoAcceptedDetail | null {
  const detail = (event as CustomEvent<MemoAcceptedDetail | undefined>).detail
  return detail && typeof detail.junctionId === 'string' ? detail : null
}

/** "MEMO-012 - Office closure", or whichever half exists. */
export function memoTitle(memo: Pick<PendingMemo, 'name' | 'subject'>) {
  return [memo.name, memo.subject].filter(Boolean).join(' - ') || 'Company memo'
}
